module.exports = __webpack_public_path__ + "img/icon-reservation.662d0748.svg";